export class MediosPago {
  codigo_medio:string='';
  nombre_medio:string='';
  tasa_medio?:number=0;
  es_vigente:boolean = false;
}
